function fnumber(number) {
  return new Intl.NumberFormat("id-ID").format(number);
}

export { fnumber };
